<template>
    <a-spin :tip="loadingTip" :spinning="isloading">
        <div>
            <div class>
                <a-form :form="form" @submit="handleSubmit">
                    <a-form-item label="所属省份" :label-col="{ span: 4 }" :wrapper-col="{ span: 19 }">
                        <a-select
                                v-model="info.province"
                                placeholder="请选择省份"
                                v-decorator="[
                'province',
                {rules: [{ required: true, message: '请选择省份!' }],initialValue:info.province}
              ]"
                        >
                            <a-select-option
                                    :value="info.name"
                                    v-for="(info, index) in areaList"
                                    :key="index"
                            >{{info.name}}</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-button type="primary" :style="{ marginleft: '100px'}" class="ui-search-action"
                              @click="chooseCourse()">价格设置
                    </a-button>
                    <a-form-item label="状态" :label-col="{ span: 4 }" :wrapper-col="{ span: 19 }">
                        <a-switch
                                v-model="info.status"
                                v-decorator="[
          'status',
          {rules: []}
        ]"
                        />
                    </a-form-item>
                    <a-table
                            :columns="list.columns"
                            rowKey="id"
                            :dataSource="list.datas"
                            :locale="{emptyText:'暂无数据'}"
                            :loading="isloading"
                            :pagination="list.pagination"
                    >
                    </a-table>
                    <a-form-item :wrapper-col="{ span: 19, offset: 5 }">
                        <pxkeji-btn name="保存" type="primary" htmlType="submit"/>
                        <pxkeji-btn name="取消" type="default" @click="cancelClick" class="cancelBtn"/>
                    </a-form-item>
                </a-form>
            </div>
            <a-modal
                    v-model="priceSetting.visible"
                    width="1000px"
                    :footer="false"
                    destroyOnClose
                    :maskClosable="false"
            >
                <priceSetting @callbackMethod="save" :id="this.id"/>
            </a-modal>
        </div>
    </a-spin>
</template>

<script>
    var that;
    var columns = [
        {
            dataIndex: "name",
            key: "name",
            align: "left",
            title: "名称"
        },
        {
            dataIndex: "price",
            key: "price",
            align: "left",
            title: "价格/元1学时"
        },

    ];
    import priceSetting from "./coursePriceSetting.vue"; //价格设置
    export default {
        props: {
            id: String
        },
        data() {
            return {
                list: {
                    columns, //表头
                    datas: [

                    ], //数据
                    pagination: {
                        //分页器
                        showQuickJumper: true,
                        hideOnSinglePage: true,
                        total: 0,
                        current: 1, //页码
                        defaultPageSize: 10 //页容
                    }
                },
                form: this.$form.createForm(this),
                areas: [],
                areaList: [],
                priceSetting: {
                    visible: false
                },
                infos: {},
                info: {
                    status: true
                },
                isloading: false,
                loadingTip: "加载中..."
            };
        },
        components: {
            priceSetting,
        },
        mounted() {
            this.$nextTick(function () {
                that = this;
                this.getArea();
                if (this.id!=0) {
                    //编辑
                    this.getInfo();

                }
            });
        },
        methods: {
            save(info) {
                this.priceSetting.visible = false;
                this.list.datas = info;

            },
            getArea() {
                this.areaList = this.$api.city.city;
            },
            chooseCourse() {
                this.priceSetting.visible = true;
            },
            areaChange(value) {
                this.info.province = value[0];
                this.info.city = value[1];
                this.info.area = value[2];
            },
            /**取消 */
            cancelClick() {
                this.$emit("callbackMethod");
            },

            destruct(forest) {
                function flatTree(tree) {
                    const queue = [tree]
                    const result = []
                    while (queue.length) {
                        let currentNode = queue.shift()
                        if (currentNode.children) {
                            currentNode.children.forEach((v) => {
                                v && queue.push(v)
                            })
                        }
                        result.push(currentNode)
                        delete currentNode.children

                    }
                    return result
                }

                if (Array.isArray(forest)) {
                    return forest.map((v) => flatTree(v)).reduce((pre, cur) => pre.concat(cur))
                } else {
                    return flatTree(forest)
                }
            },


            /**数据回显 */
            getInfo() {
                // this.info = this.infos;
                this.isloading = true;
                this.$api.courseprice
                    .getById(this.id)
                    .then(res => {
                        this.isloading = false;
                        if (res.errorCode == this.$msg.responseCode.success) {
                            this.info = res.data;
                            this.areaList.push(this.info.province);
                            this.info.status = res.data.status;
                            this.list.datas= res.data.coursetypes;
                        } else {
                            this.error(res.errorMsg);
                        }
                    })
                    .catch(() => {
                        this.isloading = false;
                    });
            },
            handleSubmit(e) {
                e.preventDefault();
                this.form.validateFields((err, values) => {
                    if (!err) {
                        var data = this.destruct(this.list.datas);
                        var jsondata=[];
                        for (let dataKey in data) {
                            var obj={};
                            obj.price=data[dataKey].price;
                            obj.id=data[dataKey].id;
                            jsondata.push(obj)
                        }
                        if (this.id!=0) {
                            //编辑
                            this.isloading = true;
                            this.loadingTip = "保存中...";
                            this.$api.courseprice
                                .update(
                                   this.id,
                                    this.info.province,
                                    this.info.status,
                                    JSON.stringify(jsondata),
                                    0

                                )
                                .then(res => {
                                    this.isloading = false;
                                    if (res.errorCode == this.$msg.responseCode.success) {
                                        this.$message.success(res.errorMsg);
                                        this.$emit("callbackMethod");
                                    } else {
                                        this.error(res.errorMsg);
                                    }
                                })
                                .catch(() => {
                                    this.isloading = false;
                                });
                        } else {
                            //新增


                            this.isloading = true;
                            this.loadingTip = "保存中...";
                            this.$api.courseprice
                                .save(
                                    this.info.province,
                                    this.$commen.changeBooleanInt(this.info.status),
                                    JSON.stringify(jsondata),
                                    0

                                )
                                .then(res => {
                                    this.isloading = false;
                                    if (res.errorCode == this.$msg.responseCode.success) {
                                        this.$message.success(res.errorMsg);
                                        this.$emit("callbackMethod");
                                    } else {
                                        this.error(res.errorMsg);
                                    }
                                })
                                .catch(() => {
                                    this.isloading = false;
                                });
                        }
                    }
                });
            },
            error(msg) {
                this.$error({
                    title: "提示",
                    content: msg == undefined ? "服务器异常" : msg,
                    okText: "返回",
                    centered: true,
                    onOk() {
                        that.$emit("callbackMethod");
                    }
                });
            }
        }
    };
</script>
<style>
    .anticon-plus-circle {
        margin-left: 10px !important;
        cursor: pointer;
    }

    .anticon-minus-circle {
        margin-left: 10px !important;
        cursor: pointer;
    }
</style>